import { services } from "@/data/services";
import SectionHeading from "@/components/SectionHeading";
import CTASection from "@/components/CTASection";
import { AlertCircle } from "lucide-react";

const Services = () => {
  if (typeof document !== "undefined") document.title = "Services — School Smiles Australia";
  return (
    <>
      <section className="container-page pt-16 md:pt-24 pb-8" data-testid="services-hero">
        <div className="max-w-3xl">
          <span className="eyebrow">What we do</span>
          <h1 className="mt-5 font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-[#14324A]">
            Preventive, child-focused dental services
          </h1>
          <p className="mt-5 text-[#4B6B86] text-lg leading-relaxed">
            Every service we offer is designed to be gentle, consent-based and clearly communicated to families. Availability on the day may depend on clinical assessment, consent and equipment.
          </p>
        </div>
      </section>

      <section className="container-page py-12 space-y-10" data-testid="services-list">
        {services.map((s, i) => (
          <article
            key={s.slug}
            id={s.slug}
            className={`card-soft p-8 md:p-12 grid grid-cols-1 lg:grid-cols-12 gap-8 items-start ${
              i % 2 === 1 ? "lg:bg-[#F4F9FF]" : ""
            }`}
            data-testid={`services-item-${s.slug}`}
          >
            <div className="lg:col-span-2">
              <div
                className="w-16 h-16 rounded-2xl inline-flex items-center justify-center"
                style={{ backgroundColor: `${s.accent}1A`, color: s.accent }}
                aria-hidden="true"
              >
                <s.icon size={30} strokeWidth={2.5} />
              </div>
            </div>
            <div className="lg:col-span-10">
              <h2 className="font-display font-bold text-2xl md:text-3xl text-[#14324A]">{s.title}</h2>
              <p className="mt-3 text-[#4B6B86] leading-relaxed">{s.long}</p>
            </div>
          </article>
        ))}

        {/* Additional service sections */}
        <article className="card-soft p-8 md:p-12" data-testid="services-item-xrays">
          <h2 className="font-display font-bold text-2xl md:text-3xl text-[#14324A]">X-rays (where clinically required and available)</h2>
          <p className="mt-3 text-[#4B6B86] leading-relaxed">
            Where clinically indicated and equipment is available, dental X-rays may be taken to support diagnosis. X-rays are only performed with consent and where they add real clinical value.
          </p>
        </article>

        <article className="card-soft p-8 md:p-12" data-testid="services-item-recommendations">
          <h2 className="font-display font-bold text-2xl md:text-3xl text-[#14324A]">Treatment recommendations & referrals</h2>
          <p className="mt-3 text-[#4B6B86] leading-relaxed">
            If your child needs treatment beyond what can be safely provided in a mobile clinic setting, we'll clearly explain what's recommended and, where helpful, refer to a suitable local dental provider.
          </p>
        </article>
      </section>

      <section className="container-page py-6" data-testid="services-disclaimer">
        <div className="rounded-3xl border border-[#FFD45C] bg-[#FFFDF7] p-8 flex gap-4">
          <AlertCircle size={22} className="text-[#14324A] shrink-0 mt-1" />
          <div>
            <h3 className="font-display font-semibold text-[#14324A]">Important information</h3>
            <p className="mt-2 text-sm text-[#4B6B86] leading-relaxed">
              Available services may depend on clinical assessment, informed consent, equipment and individual circumstances on the day. We do not guarantee specific outcomes and do not provide emergency dental care through our mobile service. Please contact your regular dentist or emergency services in case of a dental emergency.
            </p>
          </div>
        </div>
      </section>

      <div className="container-page"><CTASection testIdPrefix="services-cta" /></div>
    </>
  );
};

export default Services;
